import * as React from 'react';
import { Typography } from '../../DesignSystemV2/Typography';
import { Box, BoxProps } from '../../Common/BoxV2';

interface LabelTagProps {
  text: string;
  color: BoxProps['bg'];
  className?: string;
}

export const LabelTag = React.memo(({ text, color, className }: LabelTagProps) => (
  <Box className={className} color="white100" bg={color} borderRadius="4px" p="0 4px" width="max-content">
    <Typography.Text variant="medium/14">{text}</Typography.Text>
  </Box>
));
